/* eslint-disable no-shadow */
import 'whatwg-fetch';
import { removeItem } from '../../actions/storage';

const hostname = window && window.location && window.location.hostname;
const host = (() => {
  if (hostname === 'staging-bus.wealthscope.ca') {
    return 'https://api.staging-bus.wealthscope.ca/v1';
  }

  if (hostname === 'staging.wealthscope.ca') {
    return 'https://staging-api.wealthscope.ca/v1';
  }

  if (hostname === 'beta.wealthscope.ca') {
    return 'https://api.wealthscope.ca/v1';
  }

  if (hostname === 'bus.wealthscope.ca') {
    return 'https://api.bus.wealthscope.ca/v1';
  }

  // This allows development on localhost environments. Ideally, this whole method should be replaced with something more
  // configuration driven. For now, I'm using this `if` block to keep things consistent.
  if (hostname === 'localhost') {
    // Uncomment the following line to use remote API
    // return 'https://api.bus.wealthscope.ca/v1';
    return 'https://api.staging-bus.wealthscope.ca/v1';
  }

  return 'https://api.wealthscope.ca/v1';
})();

/**
 * Http wrapper
 */
class Api {
  constructor({ host }) {
    if (!host) {
      throw new Error('[api] Host is not specified');
    }

    this.host = host;
  }

  request(method, path, options = {}) {
    const { dispatch, token } = options;
    const url = this.host + path;

    const req = {
      url,
      method,
      headers: {},
      body: options.body,
      query: options.query,
    };

    if (options.query) {
      req.url += options.query;
    }

    if (options.body) {
      if (options.body instanceof FormData) {
        req.body = options.body; // Leave FormData as it is
      } else {
        req.body = JSON.stringify(options.body);
        req.headers['Content-Type'] = 'application/json';
      }
    }

    if (token) {
      req.headers.Authorization = `JWT ${token}`;
    }

    req.headers.Accept = 'application/json';
    // If body is FormData, don't set Content-Type manually
    if (!(options.body instanceof FormData)) {
      req.headers['Content-Type'] = 'application/json';
    }

    return new Promise((resolve, reject) => {
      fetch(req.url, req).then(
        (response) => {
          if (response.status === 401) {
            dispatch(removeItem('pwpa-token'));
            window.location.reload();
            return;
          }

          if (response.status === 404 || response.status === 429) {
            response.json().then(
              (data) => reject({ data, status: response.status }),
              (error) => reject({ error, status: response.status })
            );
            return;
          }

          if (response.status >= 200 && response.status < 300) {
            if (method === 'delete' || response.status === 204) {
              resolve();
              return;
            }

            response.text().then((text) => {
              if (!text) {
                resolve();
                return;
              }
              try {
                resolve(JSON.parse(text));
              } catch (e) {
                reject(e);
              }
            });
            return;
          }

          response.json().then(
            (data) => reject(data),
            (error) => reject(error)
          );
        },
        () => reject({ type: 'error', msg: 'Server Offline' })
      );
    });
  }
}

export default new Api({ host });
